import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Masonry/Masonry.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Masonry/Masonry.ts';

export const prototypeName = 'OzxdO9aXgAiwjAkd6KQDIDNxxV309pSMergrMlvaIjDR7LwLv8hj131A2y81HgnOxGv758U12';
export {styles};
export {script};